import _ from 'lodash'
import ServiceBasket from '@/models/service-basket'

/**
 * @type {ServiceBasketVuexState}
 */
const initialState = {
    /**
     * @type {ServiceBasket}
     */
    basket: new ServiceBasket(),
}

/**
 * @type {ServiceBasketVuexState}
 */
const state = _.cloneDeep(initialState)

export { initialState }

export default state
